import Button from '../../../common/Button/Button.tsx';
import { Modal, ModalAction, ModalBody, ModalFooter } from '../../../common/Modal/Modal.tsx';

function JoinFromCalendarPage() {
  const handleRedirect = () => {
    const rootElement = document.querySelector('#react-root');
    const redirectURL = rootElement && rootElement.getAttribute('data-url');
    window.location.replace(redirectURL || '');
  };

  return (
    <Modal title="Join from calendar" open size="Medium" onDismiss={handleRedirect}>
      <ModalBody>
        <div>
          <p>To join the meeting, do the following:</p>
          <ol>
            <li>Launch Webex LTI Legacy tool into your course.</li>
            <li>Go to the Meetings tab.</li>
            <li>Click on the Join button for the meeting you wish to join.</li>
          </ol>
          <p>Next time you can directly join the meeting from LMS calendar!</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalAction>
          <Button type="button" ariaLabel="Okay" variant="Primary" size="Default" onClick={handleRedirect}>
            OK
          </Button>
        </ModalAction>
      </ModalFooter>
    </Modal>
  );
}

export default JoinFromCalendarPage;
